<template>
    <div>
        <ProviderList v-slot="{ items, expandAll }">
            <ProviderListItem
                v-for="item in items"
                :key="item.id"
                :item="item"
                :expand="expandAll"
            />
        </ProviderList>

        <ais-pagination
            :show-first="false"
            :show-last="false"
            :padding="2"
            role="navigation"
            aria-label="Pagination"
        >
            <ul
                slot-scope="{ pages, currentRefinement, refine, isFirstPage, isLastPage }"
                class="ais-Pagination-list"
            >
                <li
                    class="ais-Pagination-item ais-Pagination-item--previousPage"
                    :class="[
                        isFirstPage
                            ? 'ais-Pagination-item--disabled cursor-not-allowed'
                            : 'cursor-pointer'
                    ]"
                >
                    <button
                        aria-label="
                            Go to previous page.
                        "
                        :disabled="isFirstPage"
                        class="ais-Pagination-link"
                        @click.prevent="refine(currentRefinement - 1)"
                        @keypress.space.prevent="refine(currentRefinement - 1)"
                    >
                        ‹
                    </button>
                    <span
                        aria-live="label"
                        :aria-label="'current page: ' + (currentRefinement + 1)"
                    ></span>
                </li>
                <li
                    v-for="page in pages"
                    :key="page"
                    class="cursor-pointer ais-Pagination-item"
                    :class="[page === currentRefinement ? 'ais-Pagination-item--selected' : '']"
                >
                    <a
                        class="ais-Pagination-link"
                        tabindex="0"
                        :aria-current="page === currentRefinement ? 'page' : null"
                        :aria-pressed="page === currentRefinement ? 'true' : 'false'"
                        :aria-label="page === currentRefinement ? null : 'Go to page ' + (page + 1)"
                        @click.prevent="refine(page)"
                        @keypress.space.prevent="refine(page)"
                    >
                        {{ page + 1 }}
                    </a>
                </li>
                <li
                    class="ais-Pagination-item ais-Pagination-item--nextPage"
                    :class="[
                        isLastPage
                            ? 'ais-Pagination-item--disabled cursor-not-allowed'
                            : 'cursor-pointer'
                    ]"
                >
                    <button
                        aria-label="Go to next page."
                        :disabled="isLastPage"
                        class="ais-Pagination-link"
                        @click.prevent="refine(currentRefinement + 1)"
                        @keypress.space.prevent="refine(currentRefinement + 1)"
                    >
                        ›
                    </button>
                </li>
            </ul>
        </ais-pagination>
    </div>
</template>

<script>
import ProviderList from './ProviderList.vue';
import ProviderListItem from './ProviderListItem.vue';

export default {
    components: {
        ProviderList,
        ProviderListItem
    },

    props: {
        mapInfo: {
            type: Object,
            default: null
        }
    }
};
</script>

<style scoped>
::v-deep {
    .ais-Pagination {
        @apply text-blue-500 py-12 mx-5;
    }

    .ais-Pagination-list {
        @apply flex items-center justify-center;
    }

    .ais-Pagination-item {
        @apply mx-2 rounded-full;
        &:focus,
        &:hover {
            @apply bg-yellow-100;
        }
    }

    .ais-Pagination-link {
        @apply flex items-center justify-center w-10 h-10;
    }

    .ais-Pagination-item--previousPage {
        @apply mr-4 text-2xl;
    }

    .ais-Pagination-item--nextPage {
        @apply ml-4 text-2xl;
    }

    .ais-Pagination-item--selected {
        @apply bg-yellow-200;
    }

    .ais-Pagination-item--disabled {
        @apply pointer-events-none;
    }
}

.alert-box {
    @apply flex items-center justify-between bg-yellow-200 mb-10 text-blue-400 p-5 rounded-md text-sm cursor-pointer;
}
</style>
